import { render, staticRenderFns } from "./PagandoPoints.vue?vue&type=template&id=cb2287c0"
import script from "./PagandoPoints.vue?vue&type=script&lang=js"
export * from "./PagandoPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports